import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LocalStorageService {
  constructor() {}

  // Function to put a key-value pair in local storage with TTL
  putWithTTL(key: string, value: any, ttlInSeconds: number = 99999999): void {
    this.cleanExpiredKeys(); // Clean expired keys before adding new data

    const expirationTime = new Date().getTime() + ttlInSeconds * 1000;
    const item = {
      value: value,
      ttl: expirationTime,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  // Function to get a value from local storage and remove if TTL has passed
  getWithTTL(key: string): any {
    this.cleanExpiredKeys(); // Clean expired keys before retrieving data

    const item = localStorage.getItem(key);

    if (!item) {
      return null; // Key not found in local storage
    }

    const parsedItem = JSON.parse(item);

    if (parsedItem.ttl && parsedItem.ttl < new Date().getTime()) {
      // TTL has passed, remove the key-value pair
      localStorage.removeItem(key);
      return null;
    }

    return parsedItem.value;
  }

  // Function to clean expired keys from local storage
  private cleanExpiredKeys(): void {
    for (let i = 0; i < localStorage.length; i++) {
      if (
        localStorage.key(i).startsWith("__") ||
        localStorage.key(i).startsWith("twk")
      ) {
        continue;
      }
      const key = localStorage.key(i);
      const item = localStorage.getItem(key);

      try {
        const parsedItem = JSON.parse(item);
        if (parsedItem.ttl && parsedItem.ttl < new Date().getTime()) {
          localStorage.removeItem(key);
        }
      } catch (e) {
        // Not a JSON value (e.g. plain string like "fr"), skip it
      }
    }
  }

  deleteKey(key: string): void {
    localStorage.removeItem(key);
  }

  public restoreDates(obj: any): void {
    if (obj === null || obj === undefined) return;
    if (typeof obj === "string") {
      return;
    }
    if (typeof obj === "object") {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const value = obj[key];
          if (typeof value === "string" && this.isISODateString(value)) {
            obj[key] = new Date(value);
          } else if (typeof value === "object" && value !== null) {
            this.restoreDates(value);
          }
        }
      }
    }
  }

  private isISODateString(value: string): boolean {
    const isoDateRegex = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{3})?Z?)?$/;
    if (!isoDateRegex.test(value)) return false;

    const date = new Date(value);
    return !isNaN(date.getTime());
  }
}
